import * as core from '../../../../../../../core'

import { query } from './subaward-details.query'

export const RESOURCE = {
  payload: {
    alias: 'sr:subaward-details',
    content: {
      segments: [
        {
          name: 'Info',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.subaward-details.widgets.info',
                    },
                  },
                },
              },
            ],
          },
          alias: 'info',
        },
        {
          name: 'Award Info',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.subaward-details.widgets.award',
                    },
                  },
                },
              },
            ],
          },
          alias: 'award-info',
        },
        {
          name: 'Subaward Risk Assessment',
          root: {
            elements: [
              {
                height: 150,
                content: {
                  row: {
                    elements: [
                      {
                        span: 3,
                        content: {
                          widget: {
                            widget: {
                              alias:
                                'sr.subaward-details.widgets.override-risk-level',
                            },
                          },
                        },
                      },
                      {
                        span: 3,
                        content: {
                          widget: {
                            widget: {
                              alias:
                                'sr.subaward-details.widgets.computed-risk-level',
                            },
                          },
                        },
                      },
                      {
                        span: 3,
                        content: {
                          widget: {
                            widget: {
                              alias:
                                'sr.subaward-details.widgets.subaward-risk-score',
                            },
                          },
                        },
                      },
                      {
                        span: 3,
                        content: {
                          widget: {
                            widget: {
                              alias:
                                'sr.subaward-details.widgets.subrecipient-risk-score',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                height: 450,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.subaward-details.widgets.risk-assessment',
                    },
                  },
                },
              },
            ],
          },
          alias: 'subaward-risk-assessment',
        },
        {
          name: 'Terms & Conditions',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'test-donut-chart',
                    },
                  },
                },
              },
            ],
          },
          alias: 'terms-and-conditions',
        },
        {
          name: 'Monitoring Activities',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'test-donut-chart',
                    },
                  },
                },
              },
            ],
          },
          alias: 'monitoring-activities',
        },
      ],
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
    },
    description: 'Subaward Details',
    name: 'Subaward Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
